module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-07.02dc323e.png";